export default __webpack_public_path__ + "static/checkheight-5fb4de5343129a505f2d271cfa44a01d.png";